import React, { useState } from 'react';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import TrackForm from './TrackForm.js';
import TrackingHistoryModal from './TrackingHistoryModal.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { useLocation } from 'react-router-dom';

const TrackCourier = () => {
    useScrollToTop();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const awb = searchParams.get("awb");
    const [trackingInfo, setTrackingInfo] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div className=''>
            <Header />

            <div className="relative isolate overflow-hidden space-y-10 bg-slate-900 py-16 sm:py-14">
                <div className="mx-auto flex flex-col lg:flex-row gap-x-3 gap-y-10 max-w-auto md:px-8 lg:px-8">
                    <TrackForm setTrackingInfo={setTrackingInfo} setModalOpen={setModalOpen} awb={awb} />
                </div>

            </div>
            <div className="grid grid-cols-1 mt-10 gap-6 sm:gap-8 px-4 sm:px-6 md:px-8 md:grid-cols-2 lg:grid-cols-3">
                {/* Column 1 */}
                <div>
                    <img
                        src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/freepik__candid-image-photography-natural-textures-highly-r__60185+(1).jpeg"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Warehouse Image 1"
                    />
                </div>

                {/* Column 2 */}
                <div className="space-y-6 sm:space-y-8 md:hidden lg:block block">
                    <img
                        src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/trackside.jpeg"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Boxes Image 1"
                    />
                    <img
                        src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/vaanside1.jpeg"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Van Side Image 2"
                    />
                </div>

                {/* Column 3 */}
                <div className="space-y-6 sm:space-y-8">
                    <img
                        src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/trackside2.jpeg"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Home Bike Image 1"
                    />
                    <img
                        src="https://uklogistics.s3.ap-south-1.amazonaws.com/UK-Logistics-Images/planeside1.jpeg"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Plane Side Image 2"
                    />
                </div>
            </div>



            <div className="mx-auto max-w-auto md:px-6 mb-7 mt-7 lg:mt-0 px-6 space-y-6 lg:px-8">
                <div className='space-y-7'>
                    <p className='font-semibold text-lg'>1. Shipment Picked
                    </p>
                    <p>This is the first step in the Shipment journey after the shipment is prepared. When the status shows "Shipment Picked," it indicates that the delivery partner has collected the package from the sender or the dispatch location. The pickup could be from a business warehouse, a store, or a personal residence. This is the moment when the package officially enters the delivery process.</p>
                    <p className='font-semibold'>What Happens During This Stage:</p>
                    <p>Once the Shipment is picked up, it is scanned into the delivery company’s system. The sender typically receives a notification that the pickup has been completed, and the recipient is notified that the item is now en route. The package might go to a local sorting facility first, where it will be processed along with other shipments going in the same direction.

                    </p>
                    <p className='font-semibold'>What You Should Know as the Sender/Receiver:</p>
                    <p>For the sender, this stage marks the beginning of the shipment's journey. It’s a good idea to keep an eye on the tracking number at this point. For the recipient, this status provides the first confirmation that the item is on its way. Depending on the Shipment service, the delivery time estimate might be updated once the pickup is confirmed.

                    </p>
                </div>


                <div className='space-y-7'>
                    <p className='font-semibold text-lg'>2. Shipment In Transit
                    </p>
                    <p>When a package is “In Transit,” it means it’s moving through the courier’s logistics system and is making its way toward the delivery address. This could involve multiple stages, including sorting, loading onto delivery vehicles, and transfers between different cities or states.</p>
                    <p className='font-semibold'>What Happens During This Stage:</p>
                    <p>Once the Shipment leaves the pickup location, it may first go to a local hub or a regional sorting center. From there, the package is sorted based on its destination. If it’s a long-distance shipment, it may travel by plane, train, or truck to another sorting facility closer to the recipient's location. Depending on the delivery network, a package may pass through multiple hubs before it reaches the final destination.

                        While "In Transit," your package might show several updates as it passes through different checkpoints, which may include arrival at sorting facilities, departure from hubs, and possible custom checks (in case of Global deliveries).

                    </p>
                    <p className='font-semibold'>What You Should Know as the Sender/Receiver:</p>
                    <p>Both the sender and the recipient can track the shipment online during this stage. As the package moves, it’s important to note that delays can happen due to various factors like weather, logistics issues, or holidays. The “In Transit” status means the package is on its way, but not yet ready for delivery.

                    </p>
                </div>

                <div className='space-y-7'>
                    <p className='font-semibold text-lg'>3. Out For Delivery
                    </p>
                    <p>The "Out for Delivery" status signifies that the package has reached the final local hub and is now with the delivery executive. The Shipment is currently on its way to the recipient's address. This stage typically happens on the day of delivery.</p>
                    <p className='font-semibold'>What Happens During This Stage:</p>
                    <p>
                        Once a package reaches the local distribution hub near the delivery address, it is assigned to a Shipment executive. They load the package onto a delivery vehicle, usually with several other deliveries for the day, and set off for the recipient’s address. This is the final phase of the journey, and the package is just hours away from being delivered.
                        Some Shipment may contact the recipient to confirm availability or provide an estimated time of arrival (ETA). The delivery vehicle may make multiple stops on the way to the recipient, so the exact delivery time can vary within the day.
                    </p>
                    <p className='font-semibold'>What You Should Know as the Sender/Receiver:</p>
                    <p>For the sender, this is the moment when the recipient is about to receive their package. It’s the last opportunity for any changes to be made to the delivery, such as changing the address or scheduling a re-delivery in case the recipient is unavailable. For the recipient, it’s important to make sure someone is present at the delivery location to sign for or collect the package. If no one is available, the Shipment may leave a note for re-delivery or drop off the package at a safe location (depending on the service).
                    </p>
                </div>

                <div className='space-y-7'>
                    <p className='font-semibold text-lg'>4. Delivered
                    </p>
                    <p>The final status, "Delivered," means that the package has successfully reached the recipient. The Shipment executive has handed it over to the recipient, someone at the address, or left it at a secure drop-off point as specified by the recipient or Shipment service.</p>
                    <p className='font-semibold'>What Happens During This Stage:</p>
                    <p>
                        Once the Shipment arrives at the delivery address, they will hand over the package to the person present. If there’s a signature required, the recipient or someone authorized will sign to confirm receipt. In some cases, the Shipment may take a photo as proof of delivery, especially for contactless deliveries.

                        If the recipient isn’t available, the Shipment may either attempt delivery again on the next business day or follow instructions like leaving the package with a neighbor, at a parcel locker, or at a designated drop-off location.
                    </p>
                    <p className='font-semibold'>What You Should Know as the Sender/Receiver:</p>
                    <p>As the sender, once the package is marked as “Delivered,” your responsibility is mostly complete, unless the recipient reports an issue (e.g., package damaged or missing). The recipient, on the other hand, should check the package for any signs of damage or tampering. If everything looks fine, the delivery is successful, and the transaction is complete.


                    </p>
                </div>

                <div className='space-y-7'>
                    <p>Tracking Your Package: Throughout these stages, the Shipment company provides a tracking number, allowing both sender and recipient to monitor the package's progress. Each status update reflects the current position or action taken on the shipment. This tracking information is essential, especially for businesses, to ensure that the shipment is proceeding smoothly.</p>
                    <p>Delays and Exceptions: Delays can happen during any of the stages mentioned above. "In Transit" can be prolonged due to bad weather, customs clearance issues, or logistical backlogs. Similarly, "Out for Delivery" may not always result in delivery on the same day if there are too many stops on the delivery route, or if no one is present to receive the package.
                    </p>
                    <p>Customer Communication: Many Shipment companies also send notifications via email, SMS, or app notifications to keep the recipient informed at each stage. The “Out for Delivery” and “Delivered” stages are particularly crucial, as this is when the recipient should ensure they are available to accept the package.
                    </p>
                    <p>Failed Delivery Attempts: If a Shipment is unable to deliver the package (for example, due to an incorrect address or no one being home), they will usually update the status to "Attempted Delivery" and provide further instructions for rescheduling or picking up the package from a local center.</p>
                </div>
            </div>

            {/* <div className="mx-auto max-w-auto md:p-6 mb-7 lg:px-8">
                <img src={table} alt="" />
            </div> */}
            <Footer />
            {modalOpen && trackingInfo && (
                <TrackingHistoryModal
                    trackingInfo={trackingInfo}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                />
            )}
        </div>
    );
};

export default TrackCourier;
